    function setupPromotedProducts(displaySecondItem = false, viewSetter = setupPromotedProductsView, mixed = false) {
        $.ajax({
            type : 'GET',
            cache: false,
            url : '/tyres/promoted',
            data: chooseAndProvideRequestData(displaySecondItem, mixed),
            success : function(view) {
               viewSetter(view)
            }
        })
    }

    function setupPromotedProductsView(view) {
        var parsedView = $($.parseHTML(view));
        parsedView.find('.last-visited-title').remove()
        $('.promoted-tyre-container').html(parsedView)

        // Setting up title out of the updated area
        if ($(".promoted-tyre-container").length > 1) {
            $('.last-visited-inner-title').attr("style", "display: none;")
            $('.daily-offer-inner-title').attr("style", "display: block;")
        }
    }

    function setupPromotedProductsViewAndProcess(view) {
        setupPromotedProductsView(view)

        var parsedView = $($.parseHTML(view));
        if (!parsedView.find('.promoted-tyre-container > a').length
            && !parsedView.find('.inline-widget-box > a').length) {
            $('.last-visited-title').remove()
        }
    }

    function provideRequestData(displaySecondItem) {
        const $form = $("#searchForm");
        LastVisitedProductJS.appendToFormLastVisitedProduct($form);
        return $form.serialize()
               + "&displaySecondItem=" + displaySecondItem
    }

    function chooseAndProvideRequestData(displaySecondItem, mixed) {
        if (!mixed) {
            return provideRequestData(displaySecondItem)
        } else {
            return provideRequestDataMixed(displaySecondItem)
        }
    }

    function provideRequestDataMixed(displaySecondItem) {
        var lineParams = provideRequestData(displaySecondItem)
        params = lineParams.split('&')
        frontParams = params.filter(name => !name.includes("frontTyreData."))
        return frontParams.join("&").replaceAll("rearTyreData.", "")
    }
